/**
 * @generated SignedSource<<7db899b9db02577095d091eb7e1d049a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RateSearchPageQuery$variables = {};
export type RateSearchPageQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"FormRateSearch_viewer" | "RecentSearches_viewer">;
  } | null;
};
export type RateSearchPageQuery = {
  response: RateSearchPageQuery$data;
  variables: RateSearchPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationId",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  (v2/*: any*/),
  (v0/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RateSearchPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FormRateSearch_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RecentSearches_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RateSearchPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "resourceType",
                    "value": "SEARCH"
                  }
                ],
                "concreteType": "TrapsResourceAllocation",
                "kind": "LinkedField",
                "name": "resourceAllocations",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "balance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isUnlimited",
                    "storageKey": null
                  }
                ],
                "storageKey": "resourceAllocations(resourceType:\"SEARCH\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegacyClientAllFieldsNode",
                    "kind": "LinkedField",
                    "name": "legacyClient",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "perSearchPricing",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IndustryNodeConnection",
            "kind": "LinkedField",
            "name": "industries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IndustryNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IndustryNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "legacyId",
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "countryId",
                "value": 0
              },
              {
                "kind": "Literal",
                "name": "industryId",
                "value": 0
              }
            ],
            "concreteType": "CountryWorkerType",
            "kind": "LinkedField",
            "name": "workerTypes",
            "plural": true,
            "selections": [
              {
                "alias": "workerTypeId",
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": "workerTypes(countryId:0,industryId:0)"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "order",
                "value": [
                  {
                    "field": "NAME"
                  }
                ]
              }
            ],
            "concreteType": "NewRegionNodeConnection",
            "kind": "LinkedField",
            "name": "regions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NewRegionNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NewRegionNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocationNode",
                        "kind": "LinkedField",
                        "name": "country",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocationNode",
                        "kind": "LinkedField",
                        "name": "locations",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LocationNode",
                            "kind": "LinkedField",
                            "name": "parent",
                            "plural": false,
                            "selections": (v4/*: any*/),
                            "storageKey": null
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "regions(order:[{\"field\":\"NAME\"}])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryListNode",
            "kind": "LinkedField",
            "name": "countries",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isoCode",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "recentSearches",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 9
              },
              {
                "kind": "Literal",
                "name": "order",
                "value": [
                  {
                    "direction": "DESC",
                    "field": "CREATE_DATE"
                  }
                ]
              }
            ],
            "concreteType": "SaveSearchNodeConnection",
            "kind": "LinkedField",
            "name": "savedsearches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SaveSearchNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SaveSearchNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "searchId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdDate",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rateType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationFullLabel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isGlobalSupplierSearch",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "workerTypeName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IndustryNode",
                        "kind": "LinkedField",
                        "name": "industry",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NewRegionNode",
                        "kind": "LinkedField",
                        "name": "region",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v5/*: any*/),
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JobResponse",
                        "kind": "LinkedField",
                        "name": "job",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobLabel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobTitleId",
                            "storageKey": null
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "savedsearches(first:9,order:[{\"direction\":\"DESC\",\"field\":\"CREATE_DATE\"}])"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "691243a98cbe6dceeb510c7cdf4f3367",
    "id": null,
    "metadata": {},
    "name": "RateSearchPageQuery",
    "operationKind": "query",
    "text": "query RateSearchPageQuery {\n  viewer {\n    ...FormRateSearch_viewer\n    ...RecentSearches_viewer\n  }\n}\n\nfragment FormRateSearch_viewer on Viewer {\n  user {\n    ...HeadingForm_user\n    ...SubmitRateSearch_user\n  }\n  ...IndustriesField_viewer\n  ...WorkerTypeField_viewer\n  ...RegionsField_viewer\n  ...SupportedCountries_viewer\n}\n\nfragment HeadingForm_user on User {\n  resourceAllocations(resourceType: SEARCH) {\n    id\n    balance\n    isUnlimited\n  }\n}\n\nfragment IndustriesField_viewer on Viewer {\n  industries {\n    edges {\n      node {\n        id\n        legacyId\n        value\n      }\n    }\n  }\n}\n\nfragment RecentSearches_viewer on Viewer {\n  recentSearches: savedsearches(first: 9, order: [{field: CREATE_DATE, direction: DESC}]) {\n    edges {\n      node {\n        id\n        searchId\n        createdDate\n        name\n        rateType\n        locationFullLabel\n        isGlobalSupplierSearch\n        workerTypeName\n        industry {\n          id\n          value\n        }\n        region {\n          name\n          regionId\n          id\n        }\n        job {\n          jobTitle\n          jobLabel\n          jobTitleId\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment RegionsField_viewer on Viewer {\n  regions(order: [{field: NAME}]) {\n    edges {\n      node {\n        country {\n          locationId\n          name\n          id\n        }\n        name\n        regionId\n        locations {\n          locationId\n          name\n          parent {\n            locationId\n            name\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment SubmitRateSearch_user on User {\n  client {\n    legacyClient {\n      perSearchPricing\n      id\n    }\n    id\n  }\n  resourceAllocations(resourceType: SEARCH) {\n    id\n    balance\n    isUnlimited\n  }\n}\n\nfragment SupportedCountries_viewer on Viewer {\n  countries {\n    id\n    isoCode\n    name\n    locationId\n  }\n}\n\nfragment WorkerTypeField_viewer on Viewer {\n  workerTypes(countryId: 0, industryId: 0) {\n    workerTypeId: id\n    name\n    description\n  }\n}\n"
  }
};
})();

(node as any).hash = "8671b2704ec29f24edd3fa5efa644d3d";

export default node;
